import { render } from "./navbar-publications.vue?vue&type=template&id=506e53be"
import script from "./navbar-publications.vue?vue&type=script&lang=js"
export * from "./navbar-publications.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__